module.exports = __webpack_public_path__ + "img/大雨-暴雨.7ab74763.png";